import { secondsSinceMidnightToTimeString } from '@/helpers/dateHelper';
import { ReadEmployee } from '@/services/gql/graphql.generated';
import { useCanEditEmployee } from '@/services/settings/useCanEditEmployee';
import { FC } from 'react';
import { FiFileText } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import { TSTitleCard } from '../../../../../components/shared/card/Card';
import { useContract } from '../../../../../services/contract/useContract';
import { strings } from '../../../../../services/translation/strings';

export const ContractDetailsCard: FC<{ employee: ReadEmployee }> = ({ employee }) => {
  const canEdit = useCanEditEmployee();

  const contract = useContract(employee.contract?.contractTypeId);

  const overtimeLabel = contract?.overtimeAllowed ? strings.timeshift.common.yes : strings.timeshift.common.no;

  const ruleContainerClass = 'flex flex-col gap-2';

  const navigate = useNavigate();
  const onEditClick = () => {
    navigate(`/team-member/${employee.identityId}/edit-contract`);
  };
  return (
    <TSTitleCard
      className="bg-white"
      title={strings.timeshift.teamMember.contractDetails.cardTitle}
      icon={FiFileText}
      primaryAction={
        canEdit
          ? {
              label: strings.timeshift.teamMember.contractDetails.edit,
              onClick: onEditClick
            }
          : undefined
      }
    >
      <div className="grid grid-cols-2 gap-4">
        <div className={ruleContainerClass}>
          <span className="font-semibold">{strings.timeshift.teamMember.contractDetails.contractName}</span>
          <span>{contract?.name ?? '-'}</span>
        </div>
        <div className={ruleContainerClass}>
          <span className="font-semibold">{strings.timeshift.teamMember.contractDetails.roleName}</span>
          <span>{employee.role}</span>
        </div>
        <div className={ruleContainerClass}>
          <span className="font-semibold">{strings.timeshift.teamMember.contractDetails.earliestStartTime}</span>
          <span>
            {contract?.earliestStartTime ? secondsSinceMidnightToTimeString(contract.earliestStartTime) : '-'}
          </span>
        </div>
        <div className={ruleContainerClass}>
          <span className="font-semibold">{strings.timeshift.teamMember.contractDetails.latestEndTime}</span>
          <span>{contract?.latestEndTime ? secondsSinceMidnightToTimeString(contract.latestEndTime) : '-'}</span>
        </div>
        <div className={ruleContainerClass}>
          <span className="font-semibold">{strings.timeshift.teamMember.contractDetails.minHoursPerWeek}</span>
          <span>{contract && contract.minHoursPerWeek ? contract.minHoursPerWeek : '-'}</span>
        </div>
        <div className={ruleContainerClass}>
          <span className="font-semibold">{strings.timeshift.teamMember.contractDetails.maxHoursPerWeek}</span>
          <span>{contract && contract.maxHoursPerWeek ? contract.maxHoursPerWeek : '-'}</span>
        </div>
        <div className={ruleContainerClass}>
          <span className="font-semibold">{strings.timeshift.teamMember.contractDetails.minHoursPerDay}</span>
          <span>{contract && contract.minHoursPerDay ? contract.minHoursPerDay : '-'}</span>
        </div>
        <div className={ruleContainerClass}>
          <span className="font-semibold">{strings.timeshift.teamMember.contractDetails.maxHoursPerDay}</span>
          <span>{contract && contract.maxHoursPerDay ? contract.maxHoursPerDay : '-'}</span>
        </div>
        <div className={ruleContainerClass}>
          <span className="font-semibold">{strings.timeshift.teamMember.contractDetails.maxDaysPerWeek}</span>
          <span>{contract && contract.maxDaysPerWeek ? contract.maxDaysPerWeek : '-'}</span>
        </div>
        <div className={ruleContainerClass}>
          <span className="font-semibold">{strings.timeshift.teamMember.contractDetails.maxConsecutiveDays}</span>
          <span>{contract && contract.maxConsecutiveDays ? contract.maxConsecutiveDays : '-'}</span>
        </div>
        <div className={ruleContainerClass}>
          <span className="font-semibold">{strings.timeshift.teamMember.contractDetails.maxShiftHours}</span>
          <span>{contract ? contract.maxHoursPerShift : '-'}</span>
        </div>
        <div className={ruleContainerClass}>
          <span className="font-semibold">{strings.timeshift.teamMember.contractDetails.allowOvertime}</span>
          <span>{contract ? overtimeLabel : '-'}</span>
        </div>
      </div>
    </TSTitleCard>
  );
};
